import React from "react";

import { Spinner } from "components";
import { Wrapper } from "./styles";

const LoadingMask = () => {
  return (
    <Wrapper>
      <Spinner size={24} color="#fff" />
    </Wrapper>
  );
};

export default LoadingMask;
